import type { ActionFunctionArgs } from '~/types/route-args';

import { passkeyLoginVerifyAction } from '~/modules/user/passkey/passkey.server';

export const PASSKEY_LOGIN_VERIFY_API_ROUTE =
    '/remix-api/user/passkey-login-verify';

export const action = (args: ActionFunctionArgs) =>
    passkeyLoginVerifyAction(args);

export type PasskeyLoginVerifyAction =
    | { ok: true; sessionEstablished: boolean }
    /**
     * `terminal` marks a credential this backend will never accept, so the
     * device can stop offering it. Optional because a server that predates the
     * signal omits it, and absent has to mean "keep the passkey".
     */
    | { ok: false; message: string; terminal?: boolean };
